import { useEffect, useState } from "react"
import Input from "../../Input"
import { toast } from "react-toastify"

const StaffList = ({ index, values, serverData }) => {
    const [sgList, setSgList] = useState([])
    const [isFormOpen, setIsFormOpen] = useState(false)
    const [editingIndex, setEditingIndex] = useState(null)
    const [formSgName, setFormSgName] = useState("")
    const [formSgID, setFormSgID] = useState("")
    useEffect(() => {
        if (!values) return
        if (values?.staffSgList) {
            try {
                const parsed = Array.isArray(values.staffSgList) ? values.staffSgList : JSON.parse(values.staffSgList)
                setSgList(parsed || [])
            } catch (err) {
                setSgList(values.staffSgList || [])
            }
        }
    }, [values])

    const resetForm = () => {
        setFormSgName("")
        setFormSgID("")
        setEditingIndex(null)
    }

    const openAddForm = () => {
        resetForm()
        setIsFormOpen(true)
    }

    const openEditForm = (index) => {
        const item = sgList[index]
        setIsFormOpen(true)
        setFormSgName(item.sgName)
        setFormSgID(item.sgID)
        setEditingIndex(index)
    }

    const cancelForm = () => {
        setIsFormOpen(false)
        resetForm()
    }

    const handleAdd = () => {
        const sgName = (formSgName || "").trim()
        const sgID = (formSgID || "").toString().trim()
        if (!sgName || !sgID) {
            toast.error("لطفا مقادیر خواسته شده را وارد کنید")
            return
        }
        if (sgList.find((r) => r.sgName === sgName)) {
            toast.error("رنک با این نام قبلا توسط شما اضافه شده است")
            return
        }
        setSgList((prev) => [...(prev || []), { sgName, sgID }])
        setIsFormOpen(false)
        resetForm()
    }

    const handleEdit = () => {
        const sgName = (formSgName || "").trim()
        const sgID = (formSgID || "").toString().trim()
        if (!sgName || !sgID) {
            toast.error("لطفا مقادیر خواسته شده را وارد کنید")
            return
        }
        const nameTakenByOther = sgList.some((r, i) => i !== editingIndex && r.sgName === sgName)
        if (nameTakenByOther) {
            toast.error("رنک با این نام قبلا توسط شما اضافه شده است")
            return
        }
        setSgList((prev) => {
            const next = [...prev]
            next[editingIndex] = { sgName, sgID }
            return next
        })
        setIsFormOpen(false)
        resetForm()
    }
    const handleDelete = () => {
        setSgList((prev) => prev.filter((_, i) => i !== editingIndex))
        setIsFormOpen(false)
        resetForm()
    }

    return (
        <div className="mx-14 h-full">
            <input name={`staffList-${index}-staffSgList`} className="hidden" value={JSON.stringify(sgList)} />
            <h6 className="flex justify-center">چنل لیست ادمین ها {index + 1}</h6>
            <div className="font-sans">
                <Input
                    type="number"
                    label="ایدی چنل *"
                    name={`staffList-${index}-id`}
                    options={serverData?.channelList}
                    placeholder="ChannelID"
                    autoComplete="off"
                    defaultValue={values?.id}
                    dir="ltr"
                />
            </div>
            <div className="mt-2">
                <div className="flex flex-wrap w-full">
                    {sgList?.map((item, index) => (
                        <div key={index}>
                            <span role="button" className="text-blue-400" onClick={() => openEditForm(index)}>
                                {item.sgName}{" "}
                            </span>
                            ,
                        </div>
                    ))}
                    <button id="rankButton" type="button" className="px-2 bg-gray-700 rounded-md" onClick={openAddForm}>
                        Add
                    </button>
                </div>
                {isFormOpen && (
                    <div>
                        <div className="flex justify-between place-items-center gap-5">
                            <div className="flex gap-5">
                                <div>
                                    <Input
                                        type="text"
                                        name={`staffList-${index}-sgName`}
                                        label="اسم رنک"
                                        placeholder="sgName"
                                        value={formSgName}
                                        autoComplete="off"
                                        dir="ltr"
                                        onChange={(e) => setFormSgName(e.target.value)}
                                    />
                                </div>
                                <div>
                                    <Input
                                        type="number"
                                        name={`staffList-${index}-sgId`}
                                        options={serverData?.sgList}
                                        label="ایدی رنک"
                                        placeholder="sgID"
                                        autoComplete="off"
                                        dir="ltr"
                                        onChange={(v) => setFormSgID(v)}
                                    />
                                </div>
                            </div>
                            {editingIndex === null ? (
                                <div className="flex gap-2">
                                    <button
                                        type="button"
                                        className="styled-button px-2 success justify-item-center mt-5 border-none"
                                        onClick={handleAdd}
                                    >
                                        اضافه
                                    </button>
                                    <button
                                        type="button"
                                        className="styled-button px-2 bg-gray-500 hover:bg-gray-600 justify-item-center mt-5 border-none"
                                        onClick={cancelForm}
                                    >
                                        بیخیال
                                    </button>
                                </div>
                            ) : (
                                <div className="flex gap-2">
                                    <button
                                        type="button"
                                        className="styled-button px-2 success justify-item-center mt-5 border-none"
                                        onClick={handleEdit}
                                    >
                                        ویرایش
                                    </button>
                                    <button
                                        type="button"
                                        className="styled-button px-2 danger justify-item-center mt-5 border-none"
                                        onClick={handleDelete}
                                    >
                                        حذف
                                    </button>
                                    <button
                                        type="button"
                                        className="styled-button px-2 bg-gray-500 hover:bg-gray-600 justify-item-center mt-5 border-none"
                                        onClick={cancelForm}
                                    >
                                        بیخیال
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
            <div className="mt-2">
                <label class="block">فرمت لیست کلاینت ها *(%users%) </label>
                <textarea
                    type="text"
                    name={`staffList-${index}-usersFormat`}
                    class="styled-input"
                    placeholder="Client List Format"
                    autoComplete="off"
                    defaultValue={values?.usersFormat}
                    dir="ltr"
                />
            </div>
            <div className="mt-2">
                <label class="block">فرمت دسکریپشن چنل *</label>
                <textarea
                    type="text"
                    name={`staffList-${index}-descFormat`}
                    class="styled-input"
                    placeholder="Description Format"
                    autoComplete="off"
                    defaultValue={values?.descFormat}
                    dir="ltr"
                />
            </div>
            <div class="flex items-start mt-2">
                <div class="flex items-center h-5">
                    <input
                        name={`staffList-${index}-clickable`}
                        type="checkbox"
                        class="  focus:ring-3 focus:ring-blue-300 h-4 w-4 rounded"
                        defaultChecked={values?.clickable}
                    />
                </div>
                <div class="text-sm mr-3">
                    <label for="foradmin" class="font-medium text-gray-300">
                        اسم های قابل کلیک
                    </label>
                </div>
            </div>
            <div dir="ltr" className="mt-5 p-2 border-gray-700 border rounded-md font-sans">
                %header%
                <br />
                لیست رنک های ادمینی
                <br />
                %header%
                <br />
                %body%
                <br />
                لیست %sg
                <br />
                %users%
                <br />
                %body%
                <br />
                %footer%
                <br />
                طراحی شده توسط ندیکس
                <br />
                %footer%
                <br />
            </div>
            <div className="mt-5 p-2 text-gray-400 border-gray-700 border rounded-md font-sans">
                <span>متغیرهای لیست کلاینت ها:</span>
                <div className="grid grid-cols-3" dir="ltr">
                    <div>%name: اسم</div>
                    <div>%i: شاخص</div>
                    <div>%ON: وضعیت انلاین به انگلیسی</div>
                    <div>%on: وضعیت انلاین به فارسی</div>
                </div>
                <span>متغیرهای دسکریپشن چنل:</span>
                <div className="grid grid-cols-1" dir="ltr">
                    <div>%users%: فیلد فرمت لیست کلاینت ها</div>
                    <div>%sg: اسم رنک که بالا گذاشتین</div>
                </div>
            </div>
        </div>
    )
}

export default StaffList
